module.exports = __webpack_public_path__ + "img/fold-vertical.1fd76b23.svg";